import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { isAuthenticated } from '@/lib/authGuard';
import { apiClient } from '@/lib/api';

/**
 * Verify admin status by calling backend API
 * Makes authenticated request to /api/v1/admin/stats to verify admin role
 */
async function verifyAdminStatus(): Promise<boolean> {
  try {
    await apiClient.get('/admin/stats');
    return true;
  } catch {
    return false;
  }
}

/**
 * Admin route - Protected route requiring authentication and admin role
 *
 * Security:
 * - Checks localStorage for auth state
 * - Verifies admin status server-side via API call
 * - Redirects to login if not authenticated
 * - Redirects to home if not admin
 */
export const adminRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin',
  beforeLoad: async ({ location }) => {
    // First check if authenticated at all
    if (!isAuthenticated()) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.pathname,
        },
      });
    }

    // Then verify admin status server-side
    const isAdmin = await verifyAdminStatus();
    if (!isAdmin) {
      throw redirect({ to: '/' });
    }
  },
  component: AdminLayout,
});

// Backward compatibility
export const Route = adminRoute;
